const CONVEX_SITE_URL = import.meta.env.VITE_CONVEX_URL?.replace(
  ".cloud",
  ".site"
) || "https://industrious-panda-719.convex.site";

export function trackDownloadClick(source: string, variant: string) {
  fetch(`${CONVEX_SITE_URL}/api/track-download`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ source, variant }),
  }).catch(() => {});
}
